/**
 * Shared colour palette. Dark "arcane dungeon" vibe with warm gold accents.
 * Numbers are 0xRRGGBB so they drop straight into Pixi fills/tints.
 */
export const Palette = {
  // Backgrounds
  bgDeep: 0x07060d,
  bgPanel: 0x16131f,
  bgPanelHi: 0x211c30,
  floor: 0x1b1726,
  floorAlt: 0x171320,
  wall: 0x2c2740,
  wallEdge: 0x4a4170,

  // Brand / accents
  arcane: 0x9d7bff,
  arcaneDim: 0x6a52b8,
  gold: 0xffcc55,
  goldDim: 0xb8923a,
  teal: 0x4fd6c8,

  // Entities
  player: 0x6cc6ff,
  playerCore: 0xe8f6ff,
  enemy: 0xd0506b,
  enemyElite: 0xe07a3a,
  boss: 0xc24bff,
  projectile: 0xbfe6ff,

  // Feedback
  hp: 0x55d977,
  hpMid: 0xe2c044,
  hpLow: 0xe05050,
  hpBack: 0x0c0a14,
  shield: 0x6fb8ff,
  danger: 0xff4d5e,
  dangerSoft: 0xff7a4d,

  // Text
  text: 0xffffff,
  textDim: 0x9a93b0,
  textGold: 0xffd97a,

  // Damage numbers
  dmg: 0xffe9a8,
  dmgCrit: 0xffae3d,
  heal: 0x76e88a,
} as const;

/** CSS hex string from a 0xRRGGBB number. */
export const css = (c: number): string => '#' + c.toString(16).padStart(6, '0');
